<p-splitButton
  [label]="label()"
  [icon]="labelIcon()"
  [model]="model()"
  [outlined]="outlined()"
  [severity]="buttonSeverity()"
></p-splitButton>
